import * as React from 'react';
import { useEffect, useState } from "react";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { Modal } from "../../../../Modal";
import { WebDate } from "../../../../WebDate";
import useFetchWebinarData from "../../../../Hooks/useFetchWebinarData";
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
const Timer = ({ id }) => {
  const deadline = useFetchWebinarData(id);
  //format example "2023-04-25T19:00:00"
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const serveDate = (deadline && deadline.next_date) && new Date(deadline.next_date);
  const mskDate = serveDate && new Date(serveDate.setHours(serveDate.getHours() + 3));

  const getTime = () => {
    const time = serveDate && (mskDate - Date.now());
    if (time > 0) {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    } else {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);
    }
  };
  const getText = (number, text) => {
    if (text === 'days') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'дней';
      let last_num = number % 10;
      if (last_num === 1) return 'день';
      if ([2, 3, 4].includes(last_num)) return 'дня';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'дней';
    } else if (text === 'hours') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'часов';
      let last_num = number % 10;
      if (last_num === 1) return 'час';
      if ([2, 3, 4].includes(last_num)) return 'часа';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'часов';
    } else if (text === 'minutes') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'минут';
      let last_num = number % 10;
      if (last_num === 1) return 'минута';
      if ([2, 3, 4].includes(last_num)) return 'минуты';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'минут';
    } else if (text === 'seconds') {
      if (number > 10 && [11, 12, 13, 14].includes(number % 100)) return 'секунд';
      let last_num = number % 10;
      if (last_num === 1) return 'секунда';
      if ([2, 3, 4].includes(last_num)) return 'секунды';
      if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'секунд';
    };
  };
  useEffect(() => {
    const interval = setInterval(() => (deadline && deadline.next_date) && getTime(mskDate), 1000);
    return () => clearInterval(interval);
  });

  return (
    <div className={screen1.timerWrap}>
      <h3>До вебинара осталось:</h3>
      <div className={screen1.timer}>
        <p><span>{days}</span> <span>{getText(days, 'days')}</span></p>
        <p><span>{hours}</span> <span>{getText(hours, 'hours')}</span></p>
        <p><span>{minutes < 10 ? '0' + minutes : minutes}</span><span>{getText(minutes, 'minutes')}</span></p>
        <p><span>{seconds < 10 ? '0' + seconds : seconds}</span> <span>{getText(seconds, 'seconds')}</span></p>
      </div>
    </div>
  );
};
export const Screen1 = ({ id, widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.timeWrap}>
          <time><WebDate id={id}/></time>
          <p className={screen1.type}>Бесплатный мастер-класс</p>
        </div>
        <h1>
          <p>Профориентация детей:</p>
          <p>что делать родителям, у которых ребёнок хочет быть только блогером или вообще ничего не хочет</p>
        </h1>
        <div className={screen1.wrapper}>
          <div className={screen1.info}>
            <Timer id={id}/>
            <div className={screen1.textWrap}>
              <p>Как взять лучшее, выбирая между качественным техническим и гуманитарным образованием</p>
              <p>Будет полезно родителям, но  можно смотреть и вместе с детьми от 14 лет и старше</p>
            </div>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться бесплатно</button>
          </div>
          <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/proforientation-mainphoto.png" alt=""/>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
